import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '../../styleSheet';
import { UI } from './tokens';

// Live UTC clock for the fleet and session views, so operators can compare the
// pipeline's UTC timestamps against the current time at a glance.
export default function UtcClock() {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => moment.utc());

  useEffect(() => {
    const interval = setInterval(() => setNow(moment.utc()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: 1.2,
        px: 1.5,
        py: 0.5,
        borderRadius: UI.radiusPill,
        backgroundColor: colors.slate100,
        boxShadow: 1,

      }}
    >
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: 'uppercase',
          color: UI.textMuted,
        }}
      >
        <AccessTimeRoundedIcon sx={{ fontSize: 12 }} />
        {t('overseer_app.pipeline_monitoring.utc_now', 'UTC now')}
      </Typography>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 700,
          color: UI.textPrimary,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {now.format('HH:mm:ss')}
      </Typography>
    </Box>
  );
}
